import { FileText } from 'lucide-react'

interface SourceCardProps {
    chunk: any
    index: number
    isCitation?: boolean
}

export function SourceCard({ chunk, index, isCitation = false }: SourceCardProps) {
    // Determine score color
    const score = chunk.score || 0
    let scoreColor = 'text-gray-400'
    if (score > 0.8) scoreColor = 'text-green-400'
    else if (score > 0.6) scoreColor = 'text-yellow-400'
    else scoreColor = 'text-red-400'

    return (
        <div className={`p-3 border rounded-lg transition-all ${isCitation ? 'bg-blue-900/10 border-blue-500/30' : 'bg-white/5 border-white/10 hover:border-white/20'}`}>
            <div className="flex justify-between items-start mb-2">
                <div className="flex items-center gap-2 overflow-hidden">
                    <div className="min-w-6 h-6 rounded bg-white/10 flex items-center justify-center text-xs font-mono text-gray-400">
                        {index + 1}
                    </div>
                    <div className="flex flex-col truncate">
                        <span className="text-xs text-gray-300 font-medium truncate" title={chunk.source_id}>
                            {chunk.metadata?.filename || chunk.source_id || 'Unknown Source'}
                        </span>
                        <span className="text-[10px] text-gray-500 truncate">
                            Page {chunk.metadata?.page || '?'} • Chunk {chunk.chunk_index || '?'}
                        </span>
                    </div>
                </div>
                <div className="flex flex-col items-end">
                    <span className={`text-xs font-mono font-bold ${scoreColor}`}>
                        {score.toFixed(3)}
                    </span>
                    {isCitation && (
                        <span className="text-[9px] uppercase tracking-wider text-blue-400 bg-blue-500/10 px-1.5 py-0.5 rounded mt-1">
                            Cited
                        </span>
                    )}
                </div>
            </div>

            <p className="text-xs text-gray-400 line-clamp-3 font-mono leading-relaxed bg-black/20 p-2 rounded">
                "{chunk.content}"
            </p>

            <div className="mt-2 flex justify-end">
                <button className="text-[10px] text-gray-500 hover:text-white flex items-center gap-1 transition-colors">
                    <FileText className="w-3 h-3" /> Ver Detalhes
                </button>
            </div>
        </div>
    )
}
